module.exports = __webpack_public_path__ + "img/icon-x-white.09b8b4b3.svg";